import { useEffect } from 'react'
import { useLocation } from 'react-router'

export const useScrollToTop = (): void => {
  const { pathname } = useLocation()

  useEffect(() => {
    document.getElementById('root')?.scrollTo({ top: 0 })
  }, [pathname])
}
